const setHeaderHeight = value => ({
    type: 'SET_HEADER_HEIGHT',
    value,
});

export default setHeaderHeight;
